export class PageStateNames {

    // ReSharper disable InconsistentNaming

    static AUTHENTICATION_LOCK = "app.pages_auth_lock";
    static AUTHENTICATION_LOGIN = "app.pages_auth_login";

    static get AUTHORIZATION_UNAUTHORIZED(): string { return "app.unauthorized"; }

    static get AUTHENTICATION_FORGOTPASSWORD(): string { return "app.pages_auth_forgot-password"; }
    static get AUTHENTICATION_REGISTER(): string { return "app.pages_auth_register"; }

    static get COMPONENTS_ACCOUNT(): string { return "app.components_account"; }
    static get COMPONENTS_CALENDAR(): string { return "app.components_calendar"; }
    //static get COMPONENTS_FLEET_DASHBOARD(): string { return "app.fleet.components_dashboard"; }
    static get COMPONENTS_DASHBOARD_OLD(): string { return "app.components_dashboard_old"; }
    //static get COMPONENTS_HELP(): string { return "app.components_help"; }
    //static get COMPONENTS_JOB(): string { return "app.components_job"; }
    //static get COMPONENTS_LIVEMAP(): string { return "app.components_livemap"; }
    //static get COMPONENTS_VEHICLES(): string { return "app.components_vehicles"; }
    //static get COMPONENTS_DRIVERS(): string { return "app.components_drivers"; }
    //static get COMPONENTS_VIDEOS(): string { return "app.cameras.components_videos"; }
    //static get COMPONENTS_MESSAGING(): string { return "app.components_messaging"; }
    static get COMPONENTS_TMS(): string { return "app.tms.components_tms"; }
    static get COMPONENTS_REPORT(): string { return "app.components_reports"; }
    //static get COMPONENTS_INSIGHTS(): string { return "app.components_insights"; }
    static get COMPONENTS_DYNAMICREPORTS(): string { return "app.components_dynamicReports"; }
    static get COMPONENTS_INTERACTIVEREPORTS(): string { return "app.components_interactiveReports"; }

    static get COMPONENTS_SETTINGS(): string { return "app.components_settings"; }
    //static get COMPONENTS_COMPLIANCE(): string { return "app.components_compliance"; }
    static get COMPONENTS_TEMPLATE(): string { return "app.components_TEMPLATE"; }
    static get COMPONENTS_WIDGETS(): string { return "app.components_widgets"; }

    static get COMPONENTS_STREAM(): string { return "app.components_stream"; }
    static get COMPONENTS_RESOURCEMANAGEMENT(): string { return "app.components_resourceManagement"; }

    static get COMPONENTS_DIAGNOSTICS(): string { return "app.components_diagnostics"; }

    static get COMPONENTS_MOBILE_ALL_VEHICLES_MAP(): string { return "app.components_mobile_all_vehicles_map"; }

    static get FOUNDATION_CUSTOMERS(): string { return "app.foundation.customers"; }
    static get FOUNDATION_CUSTOMERS_OVERVIEW(): string { return "app.foundation.customers.view"; }
    //static DEFAULT_PAGE = PageStateNames.COMPONENTS_FLEET_DASHBOARD;

    // ReSharper restore InconsistentNaming
}
